import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import 'firebase/storage'
import { firebaseConfig } from "./config";

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();

const GoogleProvider = new firebase.auth.GoogleAuthProvider();
GoogleProvider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => auth.signInWithPopup(GoogleProvider);

export const handelUserProfile = async (userAuth, additionalData) => {
  if (!userAuth) return;
  const { uid } = userAuth;

  const userRef = firestore.doc(`users/${uid}`);
  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    const { displayName, email, phoneNumber } = userAuth;
      const timestamp = new Date();
      const userRoles = ['user']

    try {
      console.log(userAuth)
      await userRef.set({
        phoneNumber,
        displayName,
        email,
        createdDate: timestamp,
        userRoles,
        ...additionalData,
      });
      }
    catch (err) {
        console.log("herereee");
        console.log(err)
      }
    }
    return userRef;
};
